export const USER_SIDEBAR_CONSTANTS = {

    ITEM_HEIGHT: 72, 
    PADDING_BUFFER: 12, 
    MIN_ITEMS: 1, 
    
    RESIZE_DEBOUNCE_DELAY: 100, 
    INITIAL_CALCULATION_DELAY: 100, 
    
    FAST_PAGE_JUMP: 5, 
    
    TITLE: 'Users',
    SEARCH_PLACEHOLDER: 'Search Users...',
    CREATE_USER_BUTTON: 'CREATE USER',
    DELETE_USER_BUTTON: 'DELETE USER',
    
    PAGINATION_BUTTON: {
      MIN_WIDTH: '36px',
      PADDING_X: 1
    },
    
    AVATAR: {
      WIDTH: 40,
      HEIGHT: 40,
      MARGIN_RIGHT: 1.5
    },
    
    TEXT_FIELD: {
      PADDING_Y: '10px',
      PADDING_LEFT: 1,
      FONT_SIZE: '14px',
      BORDER_RADIUS: '8px',
      INPUT_PADDING_LEFT: '8px',
      ADORNMENT_MARGIN_RIGHT: '8px'
    }
  } as const;
  
  export type UserSidebarConstants = typeof USER_SIDEBAR_CONSTANTS;